"use client"

import { useTheme } from "next-themes"
import { Sun, Moon } from "lucide-react"
import { useEffect, useState } from "react"

export function ThemeToggle() {
    const { theme, setTheme } = useTheme()
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    if (!mounted) return null

    return (
        <div className="inline-flex items-center rounded-md border border-white/15 bg-black/30 p-[2px] backdrop-blur">
            <button
                type="button"
                onClick={() => setTheme("light")}
                aria-pressed={theme === "light"}
                className={[
                    "flex h-8 w-8 items-center justify-center rounded-[4px] transition",
                    theme === "light"
                        ? "bg-white text-black shadow-sm"
                        : "text-white/60 hover:text-white",
                ].join(" ")}
            >
                <Sun className="h-4 w-4" />
            </button>

            <button
                type="button"
                onClick={() => setTheme("dark")}
                aria-pressed={theme === "dark"}
                className={[
                    "flex h-8 w-8 items-center justify-center rounded-[4px] transition",
                    theme === "dark"
                        ? "bg-white text-black shadow-sm"
                        : "text-white/60 hover:text-white",
                ].join(" ")}
            >
                <Moon className="h-4 w-4" />
            </button>
        </div>
    )
}
